


























































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../../Streamax/fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarPowerHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  hora: any;
  selectedItems: string[] = [];
  checkboxes: any[] = [false, false, false, false, false];
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraPowerHowen'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.formFields.powerMode.value = parseInt(this.data['?column?'].switch);
    const on = parseInt(this.data['?column?'].PowerOnTime) / 3600;
    const off = this.convertirSegundosAHora(
      parseInt(this.data['?column?'].PowerOffTime)
    );
    this.formFields.delayOff.value = parseInt(this.data['?column?'].delay);
    this.formFields.powerOn.value = moment(on, 'HHmm');
    this.formFields.powerOff.value = moment(off, 'HHmm');
    this.formFields.recDelayTime.value = this.data['?column?'].AccOffRecTime;
    this.formFields.autoReboot.value = parseInt(
      this.data['?column?'].TimeRebootEn
    );
    this.formFields.rebootTime.value = this.convertirSegundosAHora(
      parseInt(this.data['?column?'].RebootTime)
    );
    this.formFields.lowVoltagePowOff.value = parseInt(
      this.data['?column?'].LowPowerOff
    );
    this.selectedItems = this.data['channels'];
    this.checkboxes = new Array(5).fill(false);
    this.selectedItems.forEach((item: string) => {
      const index = parseInt(item);
      this.checkboxes[index] = true;
    });
  }
  mounted() {
    this.getTime();
  }
  isChecked(value: number) {
    return this.selectedItems.includes(value.toString());
  }
  convertirSegundosAHora(segundos: number): string {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const horaString = horas.toString().padStart(2, '0');
    const minutosString = minutos.toString().padStart(2, '0');
    return `${horaString}${minutosString}`;
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    powerMode: any;
    delayOff: any;
    powerOn: any;
    powerOff: any;
    recDelayTime: any;
    autoReboot: any;
    rebootTime: any;
    lowVoltagePowOff: any;
    accOffRecChl: any;
  } = {
    powerMode: {
      label: 'Power Mode',
      value: 0,
      items: [
        { label: 'OFF', id: 0 },
        { label: 'ACC', id: 1 },
        { label: 'schedule', id: 2 },
      ],
    },
    delayOff: {
      label: 'Delay Off  1~14400 MIN',
      value: '',
    },
    powerOn: {
      label: 'Power On',
      value: moment('00:00', 'HHmm'),
      selectedValue: '00:00:00',
    },
    recDelayTime: {
      label: 'Rec Delay Time 1~14400 MIN',
      value: '',
    },
    autoReboot: {
      label: 'Auto Reboot',
      value: 0,
      items: [{ label: 'OFF', id: 0 }, { label: 'ON', id: 1 }],
    },
    rebootTime: {
      label: 'Reboot Time',
      value: moment('00:00', 'HHmm'),
      selectedValue: '00:00:00',
    },
    lowVoltagePowOff: {
      label: 'Low Voltage Power Off',
      value: 0,
      items: [{ label: 'OFF', id: 0 }, { label: 'ON', id: 1 }],
    },
    powerOff: {
      label: 'Power OFF',
      value: moment('00:00', 'HHmm'),
      selectedValue: '00:00:00',
    },
    accOffRecChl: {
      label: 'Acc Off Rec Channel',
      value: 0,
      check1: true,
    },
  };
  selectedPowerMode() {
    return this.formFields.powerMode.items.find(
      (item: { id: any }) => item.id === this.formFields.powerMode.value
    );
  }
  selectedAutoReboot() {
    return this.formFields.autoReboot.items.find(
      (item: { id: any }) => item.id === this.formFields.autoReboot.value
    );
  }
  selectedLoweVoltPowOff() {
    return this.formFields.lowVoltagePowOff.items.find(
      (item: { id: any }) => item.id === this.formFields.lowVoltagePowOff.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }
  /*   validarEmail() {
        let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        return emailRegex.test(this.datoEditado.email);
      } */
  datoEditado: any = {};
  grabarEdicion(val: boolean) {
    if (val) {
      const check: String[] = [];
      this.checkboxes.forEach((item, index) => {
        if (item) check.push(index.toString());
      });
      this.datoEditado.channels = check;
      if (!this.datoEditado.channels.length) {
        this.$snotify.error('Debe estar seleccionado minimo 1 canal ', {
          timeout: 3000,
        });
        return;
      }
      console.log(this.datoEditado.channels);
      this.editar();
    }
    this.confirmCallbackConfirm(false);
  }
  async editar() {
    let self = this;
    return fetchConfiguracionStreamax(
      {
        channels: JSON.stringify(this.datoEditado.channels),
        id_camara: this.selectedValue,
        usuario: this.usuario,
      },
      'configCamaras/saveConfChannels'
    )
      .then((data: any) => {
        //console.log(data.data);
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualizacion exitosa', { timeout: 3000 });
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
    /* .finally(() => {
            return null;
          }); */
  }
  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;
    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
  }
  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
  confirmCallback(val: any) {}
  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = val;
  }
}
